import axios from "axios";
import Mgr from "@/services/SecurityService";
import ErrorHandler from "@/services/ErrorHandler";

var user = new Mgr();

const HTTP = axios.create({
  baseURL: `${process.env.API}/api/`,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN"
  },
  params: {}
});

user.getIdToken().then(
  accessToken => {
    HTTP.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
  },
  err => {
    if (process.env.NODE_ENV === "development") {
      console.log(err);
    }
  }
);

// Global error handler instance (will be initialized in main.js)
let errorHandler = null;

// Request interceptor
HTTP.interceptors.request.use(
  config => {
    // Add request timestamp for timeout tracking
    config.metadata = { startTime: new Date() };
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Response interceptor
HTTP.interceptors.response.use(
  response => {
    // Log successful responses in development
    if (process.env.NODE_ENV === "development") {
      const duration = new Date() - response.config.metadata.startTime;
      // eslint-disable-next-line no-console
      console.log(
        `✅ ${response.config.method.toUpperCase()} ${response.config.url} - ${
          response.status
        } (${duration}ms)`
      );
    }
    return response;
  },
  error => {
    if (process.env.NODE_ENV === "development") {
      console.log("HTTP Interceptor: Error caught", error);
      console.log("HTTP Interceptor: Error handler available?", !!errorHandler);
    }
    // Handle errors globally if error handler is available
    if (errorHandler) {
      errorHandler.handleError(error, {
        method: error.config?.method,
        url: error.config?.url,
        retryFunction: () => {
          return HTTP.request(error.config);
        }
      });
    } else {
      console.log("HTTP Interceptor: No error handler available");
    }

    // Return the error for component-level handling
    return Promise.reject(error);
  }
);

// Initialize error handler (called from main.js)
export const initializeErrorHandler = (store, router) => {
  errorHandler = new ErrorHandler(store, router);
};

export default HTTP;
